import { z } from 'zod';
import { Entity, Property } from '../decorators';
import transformer from './transformer';
import { zDateOptionnal } from '../zod-types';

@Entity
export class PaymentMethodModel {
  @Property(z.string())
  code!: string;

  @Property(z.string())
  type!: string;

  @Property(z.string().nullable().optional())
  typeCategory?: string;

  @Property(z.string().nullable())
  typeCategoryDescription?: string;

  @Property(zDateOptionnal.nullable())
  expirationDate?: Date;
}

export const PaymentMethodTransformer = transformer(PaymentMethodModel);
